import loadable from '@loadable/component';
import LoadingComponentLoadable from '../../components/Loading/Lazy';

const HomeLoadable = loadable(() => import(/* webpackChunkName: "home-page" */ './index'), {
  fallback: <LoadingComponentLoadable />,
});

export default HomeLoadable;
